module.exports = __webpack_public_path__ + "img/dirty_mirror.dca8c191.svg";